export default function() {
  return function(collection, role) {
    return collection.filter((by) => {
      if (role === 'staff' && by._id) {
        return true
      } else if (role === 'guest' && !by._id) {
        return true
      } else {
        return false
      }
    })
  }
}
